import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Toast } from 'primereact/toast';
import React, { useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import getRequest, { postRequest } from '../../../assets/helper/ApiHandler';
import AccountTypeIcon from '../../../assets/images/icons/account-type.svg';
import PasswordIcon from '../../../assets/images/icons/password.svg';
import UserNameIcon from '../../../assets/images/icons/username.svg';
import logo from '../../../logo.png';
import './LoginPage.css';
import axios from 'axios';
import { setAuthToken } from '../../../auth/authUtil';
import handleErrors from '../../../assets/apiEroor/ErrorHandler';
import { ApiData } from '../../../data/apiData';
import { getUserDeatils } from '../../../data/userDetails';

const LoginPage = () => {
    const [username, setUsername] = useState('admin');
    const [password, setPassword] = useState("Z9l6EU7^38jD");
    const [showPassword, setShowPassword] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [selectAccountType, setAccountType] = useState(null);
    const navigate = useNavigate();
    const toast = useRef(null);
    const user = {
        "username": username,
        "password": password,
        "rememberMe": false
    };

    const accountType = [
        { name: 'Publisher' },
        { name: 'Supply' },
        { name: 'Demand' },
        { name: 'Intermediary' },
    ];

    const handleLogin = async () => {
        const baseUrl = process.env.REACT_APP_API_ENDPOINT;
        // try {
        //     let res = await postRequest("/authenticate", user, navigate);
        //     console.log(res);
        //     setAuthToken(res.data.id_token);
        //     getUser();
        // } catch (error) {
        //     toast.current.show({ severity: "error", summary: 'Error', detail: error });
        // }
        axios.post(baseUrl + "/authenticate", user)
            .then(res => {
                setAuthToken(res.data.id_token);
                getUser();
            })
            .catch(err => {
                if (err.response && err.response.status) {
                    const errorMessage = handleErrors(err.response.status,navigate);
                    setErrorMessage(errorMessage);
                } else {
                    setErrorMessage('An error occurred. Please try again.');
                }
            });
    };


    const getUser = async () => {
        try {
            const user = await getRequest(`/account`);
            localStorage.setItem('omega_user', JSON.stringify(user));
            navigate('/dashboard');
        } catch (error) {
            //toast.current.show({ severity: "error", summary: 'Error', detail: error });
        }
    }


    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    return (
        <div className="login-container">
            <Toast ref={toast} position="top-center"></Toast>
            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }} className="logo-wrapper">
                <img src={logo} className='brand-logo' alt="logo" />
                {/* <Typography level="title-lg" className='brand-name'>Omega</Typography> */}
            </Box>
            {errorMessage && <p className="error-message">{errorMessage}</p>}
            <label className='fs-12-600'>Username</label>
            <div className="p-inputgroup flex-1">
                <span className="p-inputgroup-addon">
                    <img src={UserNameIcon} alt="Username Icon" />
                </span>
                <span className='divider'></span>
                <InputText placeholder="john.doe@example.com" value={username} onChange={(e) => setUsername(e.target.value)} />
            </div>
            <label className='fs-12-600'>Password</label>
            <div className="p-inputgroup flex-1">
                <span className="p-inputgroup-addon">
                    <img src={PasswordIcon} alt="Password Icon" />
                </span>
                <span className='divider'></span>
                {/* <InputText placeholder="Password" onChange={(e) => setPassword(e.target.value)} type={showPassword ? 'text' : 'password'} /> */}
                <Password value={password} onChange={(e) => setPassword(e.target.value)} feedback={false} />
            </div>
            {/* <label className='fs-12-600'>Account Type</label>
            <div className="p-inputgroup flex-1">
                <span className="p-inputgroup-addon">
                    <img src={AccountTypeIcon} alt="Password Icon" />
                </span>
                <span className='divider'></span>
                <Dropdown placeholder='Publisher' value={selectAccountType} onChange={(e) => setAccountType(e.value)} options={accountType} optionLabel="name" className="auto-width h-30" />
            </div> */}
            <button onClick={handleLogin} className="login-button">
                Login
            </button>
            {/* <label className="show-password">
            <input
               type="checkbox"
               onChange={togglePasswordVisibility}
               checked={showPassword}
            />{' '}
            Show Password
         </label> */}
            <Link to="/reset-password" className='forgot-password-button'>Forgot your password?</Link>
        </div>
    );
};

export default LoginPage;
